import * as React from 'react';
export const TransitionContext = /*#__PURE__*/React.createContext(null);